import React from 'react';

interface Images {
    mobileSrc?: string;
    desktopSrc?: string;
}

interface PopupProps {
    onClose: Function;
    open: boolean;
    imageSrc?: Images;
    children?: JSX.Element
}


const Popup = (props: PopupProps) => {

    return (
        <div className="popup-bg" style={{display: props.open ? 'block': 'none'}}>
        <div className="popup-container">
            <div className="popup-container__close" onClick={() => props.onClose()}>
                <i className="material-icons">&#xe5cd;</i>
            </div>
            {
                props.imageSrc &&
                <>
                    <img className="popup-container__image-desktop" src={props.imageSrc.desktopSrc}  alt={'popup image'} />
                    <img className="popup-container__image-mobile" src={props.imageSrc.mobileSrc}  alt={'popup image'} />
                </>    
            }
            <div className="popup-container__children">
                {props.children}
            </div>
        </div>
    </div>
    )
}

export default Popup;